<rosie-button [customClass]="'secondary text-sm'" (click)="createAccountModal.open()"
  [iconPrefixConfig]="{name: 'heroPlusCircle', size: '16px', strokeWidth: '2', color: '#3b3540'}"
  [translationKey]="'MULTI_ACCOUNT.CREATE_ACCOUNT'"></rosie-button>

<ngx-smart-modal #createAccountModal disableRefocus identifier="createAccountModal" [closable]="true"
  [customClass]="'create-account-modal'">
  <div class="create-account-modal-title">
    <div class="d-flex align-items-center mb-4">
      <div class="create-account-heading-icon">
        <ng-icon [name]="headingIcon" [size]="'20px'" [color]="'#822AC6'"></ng-icon>
      </div>
      <div class="create-account-heading" [innerHTML]="headingTranslation"></div>
    </div>
    <ng-container *ngIf="!isDetailsStep">
      <div class="create-account-subheading mb-2" [innerHTML]="'MULTI_ACCOUNT.TRAIN_NEW_AGENT_DESCRIPTION' | translate">
      </div>
      <div class="create-account-subheading highlighted" [innerHTML]="'MULTI_ACCOUNT.ADD_TRAINING_DATA' | translate">
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="isDetailsStep else trainingStep">
    <div class="create-account-modal-content">
      <div class="d-flex align-items-start create-account-description-wrapper">
        <div class="create-account-description-icon">
          <ng-icon [name]="'heroSparklesSolid'" [size]="'16px'" [color]="'#9332E0'"></ng-icon>
        </div>
        <div class="create-account-description" [innerHTML]="('MULTI_ACCOUNT.UNIQUELY_TRAINED' | translate)"></div>
      </div>
      <div class="d-flex align-items-start create-account-description-wrapper">
        <div class="create-account-description-icon">
          <ng-icon [name]="'heroMapPinSolid'" [size]="'16px'" [color]="'#9332E0'"></ng-icon>
        </div>
        <div class="create-account-description last" [innerHTML]="('MULTI_ACCOUNT.GREAT_FOR' | translate)"></div>
      </div>
      <div class="d-flex align-items-center create-account-description-wrapper">
        <div class="create-account-description-icon">
          <ng-icon [name]="'heroUserSolid'" [size]="'16px'" [color]="'#9332E0'"></ng-icon>
        </div>
        <div class="create-account-description" [innerHTML]="('MULTI_ACCOUNT.USE_SAME_LOGIN' | translate)"></div>
      </div>
      <div class="d-flex align-items-center create-account-description-wrapper">
        <div class="create-account-description-icon">
          <ng-icon [name]="'heroCreditCardSolid'" [size]="'16px'" [color]="'#9332E0'"></ng-icon>
        </div>
        <div class="create-account-description" [innerHTML]="('MULTI_ACCOUNT.BILLED_SEPERATELY' | translate)"></div>
      </div>
    </div>
  </ng-container>
  <div class="modal-action-line with-border justify-content-between align-items-center">
    <rosie-process-indicator [steps]="2" [step]="accountCreationStep"></rosie-process-indicator>
    <rosie-button (click)="handleAction()" class="d-block" [customClass]="'narrow slim'"
      [translationKey]="actionTranslationKey" [inProgress]="inProgress"
      [disabled]="isDetailsStep ? false : !sourceTrainingForm?.get('url')?.value && !sourceTrainingForm?.get('placeId')?.value"
      [iconSuffixConfig]="{name: (isDetailsStep ? 'heroArrowRight' : ''), size: '16px', strokeWidth: '2', color: '#EAD7FD'}">
    </rosie-button>
  </div>
</ngx-smart-modal>
<ng-template #trainingStep>
  <div class="section-item-wrapper justify-content-between account-creation-section">
    <div class="d-flex align-items-center">
      <div class="create-account-description-icon">1</div>
      <div class="section-item-label">{{ 'BUSINESS.GOOGLE_BUSINESS_PROFILE' | translate }}</div>
    </div>
    <div class="w-100">
      <rosie-google-places-search class="w-100 d-block" [showClearSelection]="hasPlaceId" [hasValue]="hasPlaceId"
        (selectionCleared)="clearSelection()" (selectedPlaceIdChanged)="onPlaceIdChanged($event)"
        [placeholder]="hasPlaceId ? (displayTrainingSources?.name || displayBusinessDetails?.title) : 'Type your business name…'"></rosie-google-places-search>
    </div>
  </div>
  <div class="section-item-wrapper justify-content-between account-creation-section">
    <div class="d-flex align-items-center">
      <div class="create-account-description-icon">2</div>
      <div class="section-item-label">{{ 'BUSINESS.WEBSITE_URL' | translate }}</div>
    </div>
    <div class="w-100">
      <rosie-text [control]="sourceTrainingForm?.get('url')" [placeholderTranslationKey]="'https://'"
        class="w-100 d-block" [type]="'url'"></rosie-text>
      <rosie-validation-error
        [show]="sourceTrainingForm?.get('url')?.errors?.pattern && sourceTrainingForm?.get('url').touched"
        [translationKey]="'COMMON.VALIDATION.URL'"></rosie-validation-error>
    </div>
  </div>
</ng-template>